import axios from 'axios'
import Cookies from 'js-cookie'
import router from '@/router'
import { useAuthStore } from '@/store/pinia/store'

let isRedirecting = false

/**
 * Определение базового адреса API (автоопределение десктопного режима Tauri).
 */
export function getApiBaseUrl() {
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL
  }
  if (typeof window !== 'undefined') {
    const isTauri = Boolean(window.__TAURI_INTERNALS__) ||
      window.location.protocol === 'tauri:' ||
      window.location.hostname === 'tauri.localhost' ||
      window.location.protocol === 'file:'

    if (isTauri) {
      return localStorage.getItem('api_base_url') || 'http://localhost'
    }
  }
  return ''
}

/**
 * Настройка глобальных перехватчиков Axios для обработки авторизации и 401 ошибок.
 */
export function setupAxios() {
  // Базовый URL (поддержка десктопных билдов и удаленного API)
  axios.defaults.baseURL = getApiBaseUrl()
  axios.defaults.withCredentials = true

  // Инициализация токена из cookies или localStorage при запуске приложения
  const token = Cookies.get('token') || (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null)
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }

  // ─── ПЕРЕХВАТЧИК ОТВЕТОВ СЕРВЕРА (RESPONSE INTERCEPTOR) ─────────────────
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status
      const url = error.config?.url || ''

      // Обработка HTTP 401 Unauthorized (сессия истекла, токен недействителен, кука удалена)
      if (status === 401) {
        // Исключаем формы входа и регистрации, чтобы ошибки неверного логина/пароля обрабатывались компонентом
        const isAuthRequest = url.includes('/api/login') || url.includes('/api/signup')

        if (!isAuthRequest) {
          try {
            const authStore = useAuthStore()
            authStore.clearAuthData()
          } catch (e) {
            Cookies.remove('user')
            Cookies.remove('token')
            delete axios.defaults.headers.common['Authorization']
          }

          // Защита от дублирующих редиректов при пачке параллельных запросов
          if (!isRedirecting) {
            isRedirecting = true

            const currentRoute = router.currentRoute.value
            const currentPath = currentRoute.fullPath
            const isAlreadyOnAuthPage = currentRoute.path === '/login' ||
                                       currentRoute.path === '/signup' ||
                                       currentRoute.path.startsWith('/auth')

            if (!isAlreadyOnAuthPage) {
              router.push({
                path: '/login',
                query: {
                  redirect: currentPath,
                  session_expired: '1'
                }
              }).finally(() => {
                setTimeout(() => {
                  isRedirecting = false
                }, 1200)
              })
            } else {
              isRedirecting = false
            }
          }

          // Помечаем ошибку специальным свойством для подавления назойливых алертов
          error.isSessionExpired = true
        }
      }

      return Promise.reject(error)
    }
  )
}

export default setupAxios
